module.exports = __webpack_public_path__ + "sv.ab9727195650a162e048.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sv.svg
// module chunks = styles